export default "__VITE_ASSET__24268dea__"